<template>
    <div class="w-100">
        <div v-for="(pair, index) in values" :key="index" class="row mb-1">
            <div class="col-sm-12">
                <div class="input-group">
                    <input type="text" :class="'form-control' + (index === values.length-1 ? ' last' : '')" v-model="values[index].name" @input="updateValue" onfocus="this.select()" />
                    <i class="fa fa-equals my-2 px-1"></i>
                    <input type="text" class="form-control" v-model="values[index].value" @input="updateValue" onfocus="this.select()" />
                    <button class="btn btn-outline-danger" @click.prevent="remove(index)" title="Remove"><i class="fa fa-minus"></i></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <button class="btn btn-outline-success w-100" @click.prevent="add"><i class="fa fa-plus"></i> Add</button>
            </div>
        </div>
    </div>
</template>
<script>
    import { Formatters } from "../common/formatters";

    export default {
        props: {
            modelValue: {
                default: () => ''
            },
        },
        data: function () {
            return {
                isString: true,
                values: [
                    //{name:'', value:''}
                ]
            };
        },
        methods: {
            add() {
                const vm = this;
                vm.values.push({ name: 'new value', value: '' });
                vm.updateValue();
                vm.$nextTick(() => {
                    let input = vm.$el.querySelector('input.last');
                    input.focus();
                });
            },
            remove(index) {
                this.values.splice(index, 1);
                this.updateValue();
            },
            fromObject(obj) {
                return Object.keys(obj).map(k => {
                    return { name: k, value: obj[k] };
                });
            },
            toObject(values) {
                let obj = {};
                values.forEach(v => {
                    obj[v.name] = v.value;
                });
                return obj;
            },
            updateValue() {
                this.$emit('update:model-value', this.isString
                    ? JSON.stringify(this.toObject(this.values))
                    : this.toObject(this.values));
            },
        },
        watch: {
            modelValue: {
                handler(value) {
                    // value should be either a string or an object (dictionary)
                    if (!Formatters.isNullOrUndef(value) && value !== '') {
                        this.isString = typeof (value) === 'string';
                        if (this.isString) this.values = this.fromObject(JSON.parse(value));
                        else this.values = this.fromObject(value);
                    } else {
                        this.values = [];
                    }
                },
                immediate: true,
            },
        },
        emits: ['update:model-value'],
    };
</script>
